module.exports = {"610881001":"滨河新区街道","610881002":"西沙街道","610881003":"麟州街道","610881004":"迎宾路街道","610881005":"永兴街道","610881006":"西沟街道","610881101":"高家堡镇","610881102":"店塔镇","610881103":"孙家岔镇","610881104":"大柳塔镇","610881105":"花石崖镇","610881106":"中鸡镇","610881107":"贺家川镇","610881108":"尔林兔镇","610881109":"万镇","610881110":"大保当镇","610881111":"马镇","610881112":"栏杆堡镇","610881113":"沙峁镇","610881114":"锦界镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610881.json
// module id = 2872
// module chunks = 0